import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppLayoutComponent} from './layout/app.layout.component';
import { authGuard } from './guards/auth.guard';
import {CallbackComponent} from "./auth/login/callback.component";


export const routes: Routes = [
    {path: '', redirectTo: '/auth/login', pathMatch: 'full'},
    {path: 'auth/id/callback', component: CallbackComponent},
    {
        path: 'users', component: AppLayoutComponent,
        children: getUserRoutes(),
        canActivate: [authGuard],
    },
    {
        path: 'officials', component: AppLayoutComponent,
        children: getOfficialsRoutes(),
        canActivate: [authGuard],
    },
    {
        path: 'mnto', component: AppLayoutComponent,
        children: getMntoRoutes(),
        canActivate: [authGuard],
    },
    {
        path: 'mnto-activar', component: AppLayoutComponent,
        children: getMntoRoutes(),
        canActivate: [authGuard],
    },
    {
        path: 'auth',
        data: {breadcrumb: 'Auth'},
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'reports',
        component: AppLayoutComponent,
        children: getReportsRoutes(),
        canActivate: [authGuard],
    },
    {path: '**', redirectTo: '/notfound'}
];

function getUserRoutes() {
    return [
        {
            path: '',
            loadChildren: () => import('./users/dashboard/dashboard.module').then(m => m.DashboardModule),
        },
        {
            path: 'dashboard',
            loadChildren: () => import('./users/dashboard/dashboard.module').then(m => m.DashboardModule),
        },
        {
            path: 'tramites',
            loadChildren: () => import('./users/tramites/tramites.module').then(m => m.TramitesModule)
        },
        {
            path: 'tramites/:idProyecto',
            loadChildren: () => import('./users/tramites/tramites.module').then(m => m.TramitesModule)
        },
        {path: 'perfil', loadChildren: () => import('./users/perfil/perfil.module').then(m => m.PerfilModule)},
        {
            path: 'proyectos',
            loadChildren: () => import('./users/proyectos/proyectos.module').then(m => m.ProyectosModule)
        },
        {path: 'pagos', loadChildren: () => import('./users/pagos/pagos.module').then(m => m.PagosModule)},
        {
            path: 'registro-profesionales',
            loadChildren: () => import('./users/registro-profesionales/registro-profesionales.module').then(m => m.RegistroProfesionalesModule)
        }
    ];
}

function getOfficialsRoutes() {
    return [
        {
            path: '',
            loadChildren: () => import('./officials/dashboard/dashboard.module').then(m => m.DashboardModule),
        }, {
            path: 'dashboard',
            loadChildren: () => import('./officials/dashboard/dashboard.module').then(m => m.DashboardModule),
        }, {
            path: 'asignaciones',
            loadChildren: () => import('./officials/asignaciones/asignaciones.module').then(m => m.AsignacionesModule)
        }, {
            path: 'inspecciones',
            loadChildren: () => import('./officials/inspecciones/inspecciones.module').then(m => m.InspeccionesModule)
        },{
            path: 'registro-profesionales',
            loadChildren: () => import('./officials/autorizaciones/autorizaciones.module').then(m => m.AutorizacionesModule)
        },{
            path: 'registro-titulares',
            loadChildren: () => import('./officials/titulares/titulares.module').then(m => m.TitularesModule)
        },
        {
            path: 'solicitud-evaluacion',
            loadChildren: () => import('./officials/evaluaciones/evaluaciones.module').then(m => m.EvaluacionesModule)
        }, {
            path: 'solicitudes-asignadas',
            loadChildren: () => import('./officials/solicitudes-asignadas/solicitudes-asignadas.module').then(m => m.SolicitudesAsignadasModule)
        },
        {
            path: 'herramientas',
            loadChildren: () => import('./officials/herramientas/herramientas.module').then(m => m.HerramientasModule)
        }

    ];
}

function getMntoRoutes() {
    return [
        {path: 'catalogo-tramites', loadChildren: () => import('./users/mnto/mnto.module').then(m => m.MntoModule)},
        {
            path: 'administracion-tramites',
            loadChildren: () => import('./users/mnto-master/mnto-master.module').then(m => m.MntoMasterModule)
        },
        {
            path: 'menus',
            loadChildren: () => import('./users/mnto-menus/mnto-menus.module').then(m => m.MntoMenusModule)
        },
        {
            path: 'roles',
            loadChildren: () => import('./users/mnto-roles/mnto-roles.module').then(m => m.MntoRolesModule)
        },
        {
            path: 'rol-menu',
            loadChildren: () => import('./users/mnto-rolmenu/mnto-rolmenu.module').then(m => m.MntoRolmenuModule)
        },
        {
            path: 'usuarios',
            loadChildren: () => import('./users/mnto-usuarios/mnto-usuarios.module').then(m => m.MntoUsuariosModule)
        },
        {
            path: 'sweetalert2',
            loadChildren: () => import('./users/mnto-sweetalert-two/mnto-sweetalert-two.module').then(m => m.MntoSweetalertTwoModule)
        },
        {
            path: 'requisitos',
            loadChildren: () => import('./users/mnto-requisitos/mnto-requisitos.module').then(m => m.MntoRequisitosModule)
        },
        {
            path: 'herramientas',
            loadChildren: () => import('./officials/herramientas/herramientas.module').then(m => m.HerramientasModule)
        },
        {
            path: 'users',
            loadChildren: () => import('./users/mnto-usuarios/mnto-usuarios.module').then(m => m.MntoUsuariosModule)
        }
    ];
}

function getReportsRoutes() {
    return [
        {
            path: '',
            loadComponent: () => import('./reports/pages/reports-dashboard/reports-dashboard.component').then(m => m.ReportsDashboardComponent),
        },
    ];
}

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true, enableTracing: false})],
    exports: [RouterModule]
})
export class AppRoutingModule {
    //Set enableTracing: true to enable detailed navigation logs
}
